export const isDosingRegimenRequired = (specialtyType?: string) => {
  if (!specialtyType) return false;

  const requiredTypesRegex = /^(SP-PA|L|SP)$/gi;
  return !!specialtyType.match(requiredTypesRegex);
};
